<div>
	<button class="accountMenuButton" [matMenuTriggerFor]="accountMenu">
		<i class="fa fa-lg fa-user fa-fw"></i>
	</button>
	<mat-menu #accountMenu="matMenu" xPosition="before">
		<ng-template matMenuContent let-item="item">
			<button mat-menu-item *ngIf="user && user.role === 'EXP'"
				class="accountActionButton" (click)="openMesAlertes()">
				<i class="fa fa-lg fa-bell fa-fw"></i> Mes alertes
			</button>
			<button mat-menu-item class="accountActionButton" (click)="logOut()">
				<i class="fa fa-lg fa-sign-out  fa-fw"></i> Me d&eacute;connecter
			</button>
		</ng-template>
	</mat-menu>
</div>